<template>
    <div id="button">
        <a type="submit" class="button" :href="links.facebookStand" target="_blank">Eveniment Facebook</a>
    </div>
</template>

<script>
import links from '@/assets/resources/links.js'
export default {
    data() {
    return {
      links,
    }
  },
}

</script>

<style lang="scss" scoped>

#button{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;
}

.button{
    margin-top: 20px;
    width: auto;
    padding-left: 5%;
    padding-right: 5%;
    padding-top: 0.53em;
    font-size: 35px;
    background-color: $primary-color;
    color: white; 
    outline: none;
    border: none;
    font-weight: bold;
  }
  .button:hover{
    color: white;
    background-color: $secondary-color;
  }
  .button:focus{
    color: white;
  }

</style>
